import React, { FC, useState } from "react";
import RHHamburgerV2 from "@RHCommerceDev/icon-hamburger-v2";
import { cn } from "@RHCommerceDev/utils/cn";
import { usePageContent } from "customProviders/LocationProvider";
import {
  CLOSE_HAMBURGER_MENU,
  OPEN_HAMBURGER_MENU
} from "resources/hamburger-nav.json";
import { useEnv } from "@RHCommerceDev/hooks/useEnv";
import yn from "yn";

export interface AnimatedHamburgerIconProps {
  isOpen?: boolean;
  color?: string;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  style?: React.CSSProperties;
}

export const AnimatedHamburgerIcon: FC<AnimatedHamburgerIconProps> = ({
  isOpen = false,
  color,
  onClick,
  style = {}
}) => {
  const { pageContent } = usePageContent();
  const [isStartAnimation, setIsStartAnimation] = useState<boolean | null>(
    null
  );
  const env = useEnv();

  const FEATURE_NEW_HEADER = yn(env?.FEATURE_NEW_HEADER);
  const CLOSE_HAMBURGER_LABEL =
    pageContent?.hamburgerNav?.CLOSE_HAMBURGER_MENU ?? CLOSE_HAMBURGER_MENU;
  const OPEN_HAMBURGER_LABEL =
    pageContent?.hamburgerNav?.OPEN_HAMBURGER_MENU ?? OPEN_HAMBURGER_MENU;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (FEATURE_NEW_HEADER) {
      setIsStartAnimation(!isOpen);
    }
    onClick?.(e);
  };

  return (
    <div
      style={!FEATURE_NEW_HEADER ? style : {}}
      className={FEATURE_NEW_HEADER ? "" : "!h-6 px-[16px] pb-[17px] pl-[10px]"}
    >
      <button
        id={FEATURE_NEW_HEADER ? "animatedHamburgerContainer" : "hamburgerIcon"}
        data-testid={"hamburgerIcon"}
        className={cn("h-6 cursor-pointer p-0", {
          "open !mt-0": isOpen,
          "flex h-4  w-full flex-col items-center justify-center gap-2":
            FEATURE_NEW_HEADER
        })}
        onClick={handleClick}
        aria-label={isOpen ? CLOSE_HAMBURGER_LABEL : OPEN_HAMBURGER_LABEL}
        aria-expanded={isOpen}
      >
        {FEATURE_NEW_HEADER ? (
          <>
            {/* Top line */}
            <span
              className={cn(
                "block w-[22px] origin-center transform border-b-[0.75px] border-current bg-transparent transition-all duration-300",
                isStartAnimation === null && isOpen
                  ? "animate-top-line-squeeze"
                  : isStartAnimation === null && !isOpen
                  ? ""
                  : isOpen
                  ? "animate-top-line-squeeze"
                  : "animate-top-line-unsqueeze"
              )}
              style={{ borderColor: color }}
            />

            {/* Middle line */}
            <span
              className={cn(
                "block w-[22px] origin-center transform border-t-[0.75px] border-current bg-transparent transition-all duration-300",
                isStartAnimation === null && isOpen
                  ? "animate-middle-line-squeeze"
                  : isStartAnimation === null && !isOpen
                  ? ""
                  : isOpen
                  ? "animate-middle-line-squeeze"
                  : "animate-middle-line-unsqueeze"
              )}
              style={{ borderColor: color }}
            />

            {/* Bottom line */}
            <span
              className={cn(
                "block w-[22px] origin-center transform border-t-[0.75px] border-current bg-transparent transition-all duration-300",
                isStartAnimation === null && !isOpen
                  ? ""
                  : isStartAnimation === null && isOpen
                  ? "animate-bottom-line-squeeze"
                  : isOpen
                  ? "animate-bottom-line-squeeze"
                  : "animate-bottom-line-unsqueeze"
              )}
              style={{ borderColor: color }}
            />
          </>
        ) : isOpen ? (
          <div className="hamburger-lines">
            <span style={{ backgroundColor: color }} />
            <span style={{ backgroundColor: color }} />
            <span style={{ backgroundColor: color }} />
          </div>
        ) : (
          <RHHamburgerV2 style={{ color }} />
        )}
      </button>
    </div>
  );
};

export default AnimatedHamburgerIcon;
